import { sha256 } from 'js-sha256';
/** Unique organisation identity used by adobe */
const ADOBE_ORG_ID = 'A7D63BC75245AE300A490D4D@AdobeOrg';
/**
 * Method to get id stitch values
 * @param emailAddress - is the user email id used for login in application
 * @returns an object of id Stitch values
 * @public
 */
export async function getIdStitchValues(emailAddress) {
    return new Promise((resolve, reject) => {
        var _a;
        const idStitchObject = {
            ADOBE_ORG_ID,
            VISITOR_API_JS_PATH: 'https://github.com/Adobe-Marketing-Cloud/id-service/releases/download/5.2.0/visitorapi.min.js',
            emailAddress: emailAddress.toLowerCase(),
            emailHash: '',
            adobeEcid: '',
        };
        (_a = document.getElementById('id-stitch-visitorapi')) === null || _a === void 0 ? void 0 : _a.remove();
        const script = document.createElement('script');
        script.src = idStitchObject.VISITOR_API_JS_PATH;
        script.defer = true;
        script.id = 'id-stitch-visitorapi';
        document.body.appendChild(script);
        script.onload = async () => {
            var _a;
            try {
                const emailHash = sha256(emailAddress.toLowerCase());
                const visitor = Visitor.getInstance(idStitchObject.ADOBE_ORG_ID);
                const visitorValues = await new Promise(resolve => visitor.getVisitorValues((values) => resolve(values)));
                visitor.setCustomerIDs({ userId: { id: emailHash, authState: (_a = Visitor === null || Visitor === void 0 ? void 0 : Visitor.AuthState) === null || _a === void 0 ? void 0 : _a.AUTHENTICATED } });
                Object.assign(idStitchObject, {
                    emailHash,
                    adobeEcid: visitorValues === null || visitorValues === void 0 ? void 0 : visitorValues.MCMID,
                    adobeProperties: {
                        adobeCustomerIds: visitor.getCustomerIDs(),
                        adobeMarketingCloudVisitorID: visitor.getMarketingCloudVisitorID(),
                        adobeVisitorValues: visitorValues,
                    },
                });
                resolve(idStitchObject);
            }
            catch (error) {
                idStitchObject.error = error;
                reject(idStitchObject);
            }
        };
        script.onerror = _error => {
            idStitchObject.error = _error;
            reject(idStitchObject);
        };
    });
}
/**
 * Method to test health of Id stitch lib
 * @returns a string msessage
 * @public
 */
export function testHealth() {
    return `Id Stitch JS test successful`;
}
/**
 * Executing this method will add trIdStitch to window object
 * @remarks This is considered a side effect and should be avoided
 * @internal
 */
export function executeSideEffects() {
    /** Window reference object */
    const _window = window;
    _window.trIdStitch = {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        version: "1.0.3",
        testHealth,
        getIdStitchValues,
    };
}
